import {
  Box,
  ListItemButton,
  Icon,
  Collapse,
  List,
  capitalize,
  ListItemSecondaryAction,
} from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import React from "react";
import FacetFilter from "models/facet-filter";
import Filter from "../filter";
import ArrowAnimation from "datalign-module-template/components/arrow-animation";

const BaseFilterList = ({
  facetType,
  facetFilters,
  index,
  open,
  OnUpdated,
  HandleOpen,
}: {
  facetType: string;
  facetFilters?: FacetFilter[];
  index: number;
  open: boolean;
  OnUpdated: (filterType: string, filter: string) => void;
  HandleOpen: (open: boolean) => void;
}) => {
  const easierTheme = useEasierTheme();
  return (
    <Box>
      <ListItemButton
        onClick={() => HandleOpen(!open)}
        sx={{
          color: easierTheme?.Colour.OnSecondary(),
          marginTop: index === 0 ? 0 : 2,
          ":hover": {
            bgcolor: easierTheme?.Colour.InverseSecondary(),
            color: easierTheme?.Colour.OnSecondaryContainer(),
          },
          ...(["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? {
                letterSpacing: 0.3,
                lineHeight: 1.6,
                fontSize: "0.813rem",
                fontWeight: 400,
                bgcolor: "#E35205",
              }
            : {
                bgcolor: easierTheme?.Colour.Secondary(),
                borderTopRightRadius: "4px",
                borderTopLeftRadius: "4px",
                borderBottomRightRadius: !open ? "4px" : undefined,
                borderBottomLeftRadius: !open ? "4px" : undefined,
              }),
        }}
      >
        {capitalize(facetType)}
        <ListItemSecondaryAction>
          <ArrowAnimation isOpen={open} />
        </ListItemSecondaryAction>
      </ListItemButton>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        sx={{
          background: easierTheme?.Colour.Surface(),
        }}
      >
        <List component="div" disablePadding>
          {facetFilters?.map((facetFilter, index) => (
            <Filter
              facetListLength={facetFilters.length}
              index={index}
              key={`filter-${facetFilter.field}`}
              filter={facetFilter}
              facetType={facetType}
              OnUpdated={OnUpdated}
            />
          ))}
        </List>
      </Collapse>
    </Box>
  );
};

export default BaseFilterList;
